<!-- TODO: Multilang :filters="local_filters"-->
<template>
  <div>
    <GenericExplorer
      v-if="local_filters"
      :filters="local_filters"
      :views="available_views(is_mobile, computer_view_props)"
      headless
      @update="update_filters"
    />
  </div>
</template>

<script>
import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   name: 'InlineBoxComunications',

   components: {
     GenericExplorer: () => import('@/components/explorer/GenericExplorer'),
   },
   props: {
     current_qunit: Object,
     props: Object,
     is_mobile: Boolean,
   },

   data: () => ({
     local_filters: new QFilters(),
     qunit_clicked: null,
     views_props: {
        'ExplorerTable': {
          'selectable': true,
          'actions': true,
          'expandable': true,
          'navigate': true,
        },
        'ExplorerCard': {
          'actions': true,
          'navigate': true,
        },
      },
   }),

   computed: {
    computer_view_props() {
      let props = this.views_props;
      props['ExplorerTable'].action_list = this.props.actions;
      props['ExplorerTable'].function = this.get_qunits;
      props['ExplorerCard'].action_list = this.props.actions;
      props['ExplorerCard'].function = this.get_qunits;
      return props;
    },
  },

  mounted(){
    this.populate_filters();
  },

  methods: {
    populate_filters() {
      this.local_filters.set_filter(get_qfilter('sort_by', 'fecha_creacion'));
      this.local_filters.set_filter(get_qfilter('sort_desc', false));
    },
    update_filters(ef) {
      //this.local_filters = new QFilters(this.local_filters).merge(ef);
    },
    clicked_qunit(qunit) {
      if (this.is_mobile && qunit) {
        this.qunit_clicked = qunit;
        this.$refs.qunit_view.open();
      }
    },
    async get_qunits(filters,token) {
      return this.current_qunit[this.props.attr].filter(filters);
    },
    available_views(is_mobile,props) {
      let views = [{name: 'ExplorerTable',...props['ExplorerTable']}];
      if (is_mobile) {
        views = [{name: 'ExplorerCard',...props['ExplorerCard']}];
      }

      return views;
    },
  },
 };
</script>

<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
